import { render } from "./BrandBanner.vue?vue&type=template&id=3eeb435e&scoped=true"
import script from "./BrandBanner.vue?vue&type=script&lang=js"
export * from "./BrandBanner.vue?vue&type=script&lang=js"

import "./BrandBanner.vue?vue&type=style&index=0&id=3eeb435e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eeb435e"]])

export default __exports__